import React from "react";
import { Box, Typography } from "@mui/material";
import InboxIcon from "@mui/icons-material/InboxOutlined";

/**
 * Shown in place of a list/table when there is nothing to display. Give it an
 * `action` (usually the same primary button as the page header) so an empty
 * screen still offers the next step.
 */
export default function EmptyState({
  icon: Icon = InboxIcon,
  title = "Nothing here yet",
  description,
  action,
  dense = false,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 3,
        py: dense ? 4 : 8,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 3,
          display: "grid",
          placeItems: "center",
          bgcolor: "background.subtle",
          color: "text.secondary",
          mb: 2,
        }}
      >
        <Icon sx={{ fontSize: 28 }} />
      </Box>
      <Typography variant="h5" sx={{ mb: 0.5 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380 }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: 2.5 }}>{action}</Box>}
    </Box>
  );
}
